import React from "react";
export function Footer() {
  return <footer className="bg-berryDark px-4 py-10 text-center text-white" data-id="element-150" data-mp="19ivlq3plplne">
      <p className="font-serif text-[20px] font-bold" data-id="element-151" data-mp="206j4fl6s0ffg">Nail Course In A Box™</p>
      <p className="mt-1 text-[14px] text-petal" data-id="element-152" data-mp="2f5d3l67emymz">Created by Emily Carter</p>
      <p className="mt-4 text-[13px] text-white/70" data-id="element-153" data-mp="2a5qsb2b4zsgt">© 2026 Nail Course In A Box™. All Rights Reserved.</p>
    </footer>;
}